<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>User Public Profile</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">
  <mat-tab-group>
    <mat-tab label="Details">
      <app-user-public-profile-details [user]="user"></app-user-public-profile-details>
    </mat-tab>

    <mat-tab label="Training/Competencies">
      <app-user-public-profile-training-docs [hash]="hash"></app-user-public-profile-training-docs>
    </mat-tab>

    <mat-tab label="Assigned Forms">
      <app-user-public-profile-assigned-forms [hash]="hash"></app-user-public-profile-assigned-forms>
    </mat-tab>

    <mat-tab label="{{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }} Visited">
      <app-user-public-profile-sites-visited [hash]="hash" [includeAdminActions]="true"></app-user-public-profile-sites-visited>
    </mat-tab>

    <mat-tab label="{{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }} Worked On">
      <app-user-public-profile-sites-worked-on [hash]="hash" [includeAdminActions]="true"></app-user-public-profile-sites-worked-on>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1">
  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    type="button"
    color="primary"
    aria-label="Share"
    (click)="onOpenUrl(shareLink)"
  >
    <mat-icon>open_in_new</mat-icon>
    Share
  </button>

  <button
    mat-button
    type="button"
    ngxClipboard
    [cbContent]="shareLink"
    (click)="notifyCopied()"
    class="my-2 ml-1 mr-2"
    matTooltip="Copy link to clipboard">
    <mat-icon>file_copy</mat-icon>
    Copy Link
  </button>
</mat-dialog-actions>
